import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { discordAPI } from "../../../api/apiClient";
import useApi from "../../CustomHooks/useApi";
import { FaPoll, FaDonate, FaKey, FaChevronDown, FaChevronUp } from "react-icons/fa";
import "../../../css/DiscordChannelsSection.css";
import Loading from "../../../Loading";
import { useTripContext } from "../TripContext";
import AddDiscordChannelModal from "./AddDisordChannelModal";


const DiscordChannelsSection = () => {
  const { guid: tripGuid } = useParams();
  const [channels, setChannels] = useState([]);
  const [expandedChannelId, setExpandedChannelId] = useState(null);
  const [newChannelName, setNewChannelName] = useState("");
  const [selectedVariants, setSelectedVariants] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { tripData } = useTripContext();
  const { callApi, isLoading } = useApi();

  const fetchChannels = () => {
    if (!tripGuid) return;
    callApi(
      () => discordAPI.channels.getChannelsForTrip(tripGuid),
      (data) => setChannels(data)
    );
  };

  useEffect(() => {
    fetchChannels();
  }, [tripGuid]);


  const usedVariantGuids = channels.flatMap((ch) => ch.variantGuids || []);


    const availableVariants = tripData?.variants.filter(
    (v) => !usedVariantGuids.includes(v.guid)
    ) || [];

  return (
    <div className="discord-section">
      <h2 className="discord-title">Kanały Discord</h2>
<div className="discord-create-wrapper">
  <button className="discord-create-btn" onClick={() => setIsModalOpen(true)}>
    + Utwórz nowy kanał
  </button>
</div>
      {isLoading ? (
        <Loading text="Ładowanie danych" />
      ) : channels.length === 0 ? (
        <p className="discord-empty">Brak powiązanych kanałów.</p>
      ) : (
<div className="discord-channel-list">
  <p className="discord-tip">
Wybierz kanał, aby zarządzać dostępem osób uczestniczących.
</p>
  {channels.map((ch) => {
    const variantNames = (ch.variantGuids || [])
      .map((guid) => tripData?.variants.find((v) => v.guid === guid)?.name)
      .filter(Boolean);

    return (
      <Link
        to={`${ch.id}`}
        key={ch.id}
        className="discord-channel-card-link"
      >
        <div className="discord-channel-card">
          <div className="discord-channel-variants-tags">
            {variantNames.map((name, idx) => (
              <span key={idx} className="variant-tag">
                {name}
              </span>
            ))}
          </div>
          <div className="discord-channel-header">#{ch.name}</div>
        </div>
      </Link>

    );
  })}
</div>

      )}
      <AddDiscordChannelModal
  isOpen={isModalOpen}
  onClose={() => setIsModalOpen(false)}
  tripData={tripData}
  onCreate={(name, variantGuids) => {
    callApi(() =>
      discordAPI.channels.addChannel(tripGuid, {
        name,
        creators: [],
        variantGuids,
      }),
      () => {
        fetchChannels();
      }
    );
  }}
  availableVariants={availableVariants}
/>

    </div>
  );
};

export default DiscordChannelsSection;
